function ExperienceIconJobDetails({ iconWidthAndHeight = "56" }) {
  return (
    <svg
      width={`${iconWidthAndHeight}`}
      height={`${iconWidthAndHeight}`}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1106_5468"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="56"
      >
        <path d="M0 0H56V56H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1106_5468)">
        <path
          d="M54.3594 12.0313V20.125H1.64062V12.0313C1.64062 10.2189 3.10953 8.75 4.92187 8.75H51.0781C52.8905 8.75 54.3594 10.2189 54.3594 12.0313Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 13.125V4.375"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 13.125V4.375"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.5 13.125V4.375"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 28.875H15.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 35.875H15.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 42.875H15.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.25 28.875H29.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.25 35.875H29.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.25 42.875H29.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.25 28.875H43.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.25 35.875H43.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.25 42.875H43.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.0781 51.625H4.92187C3.10975 51.625 1.64062 50.1559 1.64062 48.3438V12.0313C1.64062 10.2191 3.10975 8.75 4.92187 8.75H51.0781C52.8902 8.75 54.3594 10.2191 54.3594 12.0313V48.3438C54.3594 50.1559 52.8902 51.625 51.0781 51.625Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default ExperienceIconJobDetails;
